module.exports = __webpack_public_path__ + "media/application/images/icons/youtube-c82d5fa8e5eaadf6daf94a4cb5ebe232.svg";